(($, Drupal) => {
  const id = "xencms:block--languageswitcher";

  Drupal.behaviors[id] = {
    attach: (context, settings) => {
      $(once('languages-switcher', '.language-switcher--select', context)).on('click', function (event) {
        const $wrapper = $(this).closest('.language-switcher--wrapper');
        if ($wrapper.hasClass('is-open')) {
          $wrapper.removeClass('is-open');
        } else {
          $wrapper.addClass('is-open');
        }
      });
    }
  };

})(jQuery, Drupal);

